import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface TimeZoneState {
  timeZone: string;
  setTimeZone: (value: string) => void;
}

const useTimeZoneStore = create<TimeZoneState>()(
  persist(
    (set) => ({
      timeZone: 'America/Chicago',
      setTimeZone: (value: string) => set({ timeZone: value }),
    }),
    {
      name: 'time-zone-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export { useTimeZoneStore };
